import * as Yup from 'yup';

export const ConnectWarehouseFormSchema = Yup.object().shape({
  warehouseId: Yup.string().trim().required('Select send to warehouse'),
  buyigRate: Yup.string().trim().required('Please select the rates'),
  awb: Yup.string().trim(),
});
